import { commonTranslations, I18N_NS } from '@sbercloud/common-translations';
import { getTranslationResolver } from '../helpers';
export var resolveCommonTranslations = getTranslationResolver({
  PageLayout: {
    PageForm: {
      "continue": commonTranslations.buttons["continue"],
      create: commonTranslations.buttons.create,
      save: commonTranslations.buttons.save,
      cancel: commonTranslations.buttons.cancel,
      back: commonTranslations.buttons.back,
      rent: commonTranslations.buttons.rent,
      send: commonTranslations.buttons.send,
      restore: commonTranslations.buttons.restore
    }
  },
  ModalPredefined: {
    cancel: commonTranslations.buttons.cancel
  }
}, I18N_NS);